import css from './CartBox.css'
import { show, hide } from '../../lib/jsfunc.js'
import { on, ready, query } from '../../lib/dom.js'

ready(function(){
  if(query('.NavMenu')){
    hide('.CartBox');
  }
})

on('mouseover', '.CartBox', function(event) {
  if(!query('.NavMenu')){
    show('div.infolayer-cart-popup');
    if(query('.infolayer-cart-popup div form table td.anzahl input'))
      setTimeout(query('.infolayer-cart-popup div form table td.anzahl input').focus(),0); 
  }
})

